import { z } from 'zod';
import { c } from '../contract';
import { discoveryContentResolve } from '../schemas/discovery.schema';

export const discoveryRouter = c.router(
  {
    loadMore: {
      summary: 'Load Discovery Shelves',
      method: 'GET',
      path: '/content',
      query: z.object({
        last_seen_shelf_slug: z.string().optional(),
        language: z.string().optional(),
      }),
      responses: {
        500: z.literal('Internal Server Error'),
        200: discoveryContentResolve,
      },
    },
  },
  { pathPrefix: '/discovery' },
);
